import { render, staticRenderFns } from "./twofactor-enabled-card.vue?vue&type=template&id=0e53ec60&scoped=true"
import script from "./twofactor-enabled-card.vue?vue&type=script&lang=ts"
export * from "./twofactor-enabled-card.vue?vue&type=script&lang=ts"
import style0 from "./twofactor-enabled-card.vue?vue&type=style&index=0&id=0e53ec60&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e53ec60",
  null
  
)

export default component.exports